export default __webpack_public_path__ + "static/media/Ram.fd0578f5.png";